import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
// Limitless imports
import { calculateReviewSummary } from "../../../../utils";
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import OnboaringReviewCriteriaFeedback from "./OnboaringReviewCriteriaFeedback";
import OnboardingAnswerTypeSummary from "./OnboardingAnswerTypeSummary";
import BoxRenderer from "../../../box-renderer/BoxRenderer";
const useStyles = makeStyles(theme => ({
  summaryContainer: {
    margin: "8px 0px 16px 0px",
    width: "100%"
  },
  scoreBubble: {
    backgroundColor: theme.palette.primary.main,
    padding: 4
  },
  scoreContainer: {
    width: "100%",
    marginBottom: 8
  }
}));
const OnboardingReviewCriteriaSummary = ({
  message
}) => {
  var _message$reviewNotes, _message$reviewNotes$;
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const reviewSummary = React.useMemo(() => calculateReviewSummary(message, true), [message.messageId]);
  const showReviewScore = message.reviewCriteria.some(criteria => typeof criteria.score === "number");
  //show no review criteria for escalation questions
  const criteria = message.onboarding.responseType === "esc" || !reviewSummary.hasCorrectReply ? [] : message.reviewCriteria;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1,
    direction: "column",
    className: classes.summaryContainer
  }, showReviewScore ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OnboardingAnswerTypeSummary, {
    reviewSummary: reviewSummary,
    message: message
  })) : /*#__PURE__*/React.createElement(BoxRenderer, {
    showRadius: true,
    color: "secondary-main",
    value: t("This practice task has not been reviewed yet"),
    variant: "caption",
    containerStyles: {
      padding: "4px 12px"
    },
    noMargin: true,
    id: "reviewsummary"
  }), showReviewScore && /*#__PURE__*/React.createElement(OnboaringReviewCriteriaFeedback, {
    reviewNotesEnabled: ((_message$reviewNotes = message.reviewNotes) === null || _message$reviewNotes === void 0 ? void 0 : _message$reviewNotes.length) > 0,
    reviewCriteria: criteria,
    reviewNote: (_message$reviewNotes$ = message.reviewNotes[0]) === null || _message$reviewNotes$ === void 0 ? void 0 : _message$reviewNotes$.note
  }));
};
OnboardingReviewCriteriaSummary.propTypes = {
  message: PropTypes.object.isRequired
};
export default OnboardingReviewCriteriaSummary;